var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import clsx from 'clsx';
import { makeStyles, Menu, MenuItem } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import { MenuPositions } from './enums';
import { DefaultTheme } from '../../themes/DefaultTheme';
var spacing = DefaultTheme.spacing;
var menuPadding = {
    menu_item_radius: spacing(0.5),
    menu_padding: spacing(2),
};
var positions = new Map([
    [
        MenuPositions.BOTTOM,
        {
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            },
            transformOrigin: {
                vertical: 'top',
                horizontal: 'center',
            },
        },
    ],
    [
        MenuPositions.TOP,
        {
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'center',
            },
            transformOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            },
        },
    ],
]);
var useStyles = makeStyles(function (_a) {
    var palette = _a.palette, spacing = _a.spacing;
    return ({
        paper: function (_a) {
            var menu_padding = _a.menu_padding, minWidth = _a.minWidth, position = _a.position, width = _a.width;
            var marginTop = position === MenuPositions.BOTTOM ? spacing(1) : 0;
            var menuWidth = width && typeof width === 'number' ? width + "px" : width;
            return {
                borderRadius: spacing(1),
                marginTop: marginTop,
                minWidth: minWidth || spacing(21),
                padding: menu_padding,
                width: menuWidth,
            };
        },
        listItem: function (_a) {
            var menu_item_radius = _a.menu_item_radius;
            return {
                borderRadius: menu_item_radius,
                color: palette.secondary.main,
                padding: spacing(1.25, 2),
            };
        },
        icon: {
            marginRight: spacing(1),
            pointerEvents: 'none',
        },
        blank: {
            color: 'transparent',
        },
        checkmark: {
            color: palette.secondary.main,
        },
    });
});
var usePopoverStyles = makeStyles(function () { return ({
    root: {
        zIndex: "20000 !important",
    },
}); });
export var LanguageMenu = function (_a) {
    var anchor = _a.anchor, availableLanguages = _a.availableLanguages, curLang = _a.curLang, handleClose = _a.handleClose, minWidth = _a.minWidth, open = _a.open, padMenu = _a.padMenu, position = _a.position, width = _a.width;
    var componentStyle = padMenu ? menuPadding : null;
    var classes = useStyles(__assign(__assign({}, componentStyle), { minWidth: minWidth, position: position, width: width }));
    var popoverClasses = usePopoverStyles();
    var _b = positions.get(position), anchorOrigin = _b.anchorOrigin, transformOrigin = _b.transformOrigin;
    function getLangaugeListItems() {
        var e_1, _a;
        var items = [];
        try {
            for (var availableLanguages_1 = __values(availableLanguages), availableLanguages_1_1 = availableLanguages_1.next(); !availableLanguages_1_1.done; availableLanguages_1_1 = availableLanguages_1.next()) {
                var _b = __read(availableLanguages_1_1.value, 2), key = _b[0], value = _b[1];
                var selected = key === curLang;
                items.push(React.createElement(MenuItem, { className: classes.listItem, key: key, onClick: handleClose, selected: selected, value: key },
                    !selected && React.createElement(CheckBoxOutlineBlankIcon, { className: clsx(classes.icon, classes.blank) }),
                    selected && React.createElement(CheckIcon, { className: clsx(classes.icon, classes.checkmark) }),
                    value));
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (availableLanguages_1_1 && !availableLanguages_1_1.done && (_a = availableLanguages_1.return)) _a.call(availableLanguages_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return items;
    }
    return (React.createElement(Menu, { anchorEl: anchor, anchorOrigin: anchorOrigin, classes: { paper: classes.paper }, getContentAnchorEl: null, id: "user-language-menu", onClose: handleClose, open: open, transformOrigin: transformOrigin, PopoverClasses: popoverClasses, MenuListProps: {
            'aria-labelledby': 'user-language-menu-trigger',
        } }, getLangaugeListItems()));
};
//# sourceMappingURL=LanguageMenu.js.map